import React, { createContext } from 'react';
import { Configure2faResponse } from 'Services/Api/AccountService';

export type InitialSetupArguments = {
	userName: string;
	loggedInUserName?: string;
	configurePromise: Promise<Configure2faResponse>;
	close: (dataUnchanged?: boolean) => void;
};

export type RemoveArguments = {
	userName: string;
	close: (dataUnchanged?: boolean) => void;
};

export type LoginArguments = {
	onTwoFactorSuccess?: () => void;
	rememberMe?: boolean;
	userName?: string;
};

export type TwoFactorResponse = {
	content: React.ReactNode;
	required: boolean;
};

export interface TwoFactorConfiguration {
	onInitialSetup: (args: InitialSetupArguments) => TwoFactorResponse;
	onRemove: (args: RemoveArguments) => TwoFactorResponse;
	onLogin: (args: LoginArguments) => TwoFactorResponse;
}

export interface TwoFactorMethods {
	[name: string]: TwoFactorConfiguration;
}
export const TwoFactorContext = createContext<TwoFactorMethods>({});
